import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment-timezone';
import { CircularProgress, Box } from '@mui/material';

import PaymentDetailsComponent from './PaymentDetailsComponent';

import { usePaymentDetails } from '../../../../hooks/queries/usePaymentDetails';
import {
  useDownloadInvoice,
  useDownloadReceipt,
} from '../../../../hooks/queries/postDownloadInvoice';

import { PROFILE_ROUTES, ROUTES } from '../../../../constants/paths';
import { styles } from './styles';

const PaymentDetails = () => {
  const { id } = useParams<{ id: string }>();

  const { payment, isLoading } = usePaymentDetails(id || '');
  const { downloadInvoice } = useDownloadInvoice();
  const { downloadReceipt } = useDownloadReceipt();

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(ROUTES.PROFILE + PROFILE_ROUTES.PAYMENT_HISTORY);
  };

  const handleDownloadInvoice = async () => {
    if (payment?.invoice_id) {
      const invoiceData = await downloadInvoice({
        invoice_id: payment?.invoice_id,
      });

      if (!invoiceData) return;

      const blob = new Blob([invoiceData], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `Invoice_${moment().format('DD_MMM_YYYY')}.pdf`;

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  };

  const handleReceiptDownload = async () => {
    if (payment?.id) {
      const receiptData = await downloadReceipt({ payment_id: payment?.id });

      if (!receiptData) return;

      const blob = new Blob([receiptData], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = `Receipt_${moment().format('DD_MMM_YYYY')}.pdf`;

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  };

  if (isLoading) {
    return (
      <Box sx={styles.summaryLoader}>
        <CircularProgress />
      </Box>
    );
  }

  if (!payment) {
    return null;
  }

  return (
    <PaymentDetailsComponent
      payment={payment}
      handleBackClick={handleBackClick}
      handleDownloadInvoice={handleDownloadInvoice}
      handleReceiptDownload={handleReceiptDownload}
    />
  );
};

export default PaymentDetails;
